module.exports = __webpack_public_path__ + "static/media/map-offices.3e2d47fe.png";